// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktop":"ui_a","AdSlotBranding__mobile":"ui_b","AdSlotBranding--branding":"ui_c","body--branding":"ui_e","body--billboard":"ui_f"};